module.exports = __webpack_public_path__ + "img/xwtitle.0ac1c9c6.png";